export default __webpack_public_path__ + "static/media/editFromCancel.f7eb6c44.svg";